import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import {
  SpeedCoachingProfile,
  speedCoachingProfileSchema,
} from '../schemas/speed-coaching-profile.schema';

/**
 * Creates a new Speed Coaching Profile
 * @param speedCoachingProfile The Speed Coaching Profile being created
 * @returns Data object containing the created Speed Coaching Profile
 */
export function postSpeedCoaching(
  this: unknown,
  speedCoachingProfile: Partial<SpeedCoachingProfile>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).speedCoachingUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(speedCoachingProfile),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: speedCoachingProfileSchema,
      })
    )
  );
}
